import RequestProductService from "@/services/v3/requests/request-products.service";
import ErrorHandlerService from "@/services/ErrorHandlerService";
import { REPLENISHMENT_LABELS, replenishmentLabel } from "@/helpers/replenishment";

// Same "alterar tipo de reabastecimento" flow already used by the Produtos
// tab (_products.tab.vue) — reused here for tables that key products as
// `product.id` / `product.name` (the pre_orders_report() shape) instead of
// the Produtos tab's `pro_id` / `pro_descricao`. Emits 'reload' instead of
// mutating the clicked row in place, since the same product can appear in
// several rows across stores/providers in these tables.
export const replenishmentStrategyMixin = {
    data() {
        return {
            replenishmentSvc: new RequestProductService(),
            savingReplenishment: null,
        };
    },
    methods: {
        promptReplenishmentStrategy(product) {
            const currentLabel = replenishmentLabel(product.replenishment_strategy);

            this.$swal
                .fire({
                    title: "Alterar tipo de reabastecimento",
                    text: currentLabel
                        ? `${product.name} — tipo atual: ${currentLabel}.`
                        : `${product.name} — ainda sem tipo de reabastecimento definido.`,
                    input: "select",
                    inputOptions: REPLENISHMENT_LABELS,
                    inputValue: product.replenishment_strategy || undefined,
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Salvar",
                    inputValidator: (value) => {
                        if (!value) {
                            return "Você precisa escolher um tipo!";
                        }
                    },
                })
                .then((result) => {
                    if (result.value && result.value !== product.replenishment_strategy) {
                        this.saveReplenishmentStrategy(product, result.value);
                    }
                });
        },
        saveReplenishmentStrategy(product, strategy) {
            this.savingReplenishment = product.id;

            this.replenishmentSvc
                .update_replenishment_strategy(this.$route.params.id, product.id, strategy)
                .then(() => {
                    this.$swal.fire("Atualizado!", "Reabastecimento alterado com sucesso.", "success");
                    this.$emit("reload");
                })
                .catch((error) => {
                    ErrorHandlerService.handle(error, this.$store);
                    this.$swal.fire("Erro!", "Não foi possível atualizar o reabastecimento.", "error");
                })
                .finally(() => {
                    this.savingReplenishment = null;
                });
        },
    },
};
